<template>
  <div class="wrapper">
    <HeaderNav title="商家比例" v-if="!isMobile"></HeaderNav>
    <div class="container">
      <div class="set-default" @click="setDefault">设为默认值</div>
      <div class="section">
        <div class="row" v-if="packageInfo.setMealAnnualFee === 1">
          <div class="row-name">年费</div>
          <div class="row-cont">
            <input type="text" placeholder="输入年费" v-model="businessScaleForm.setMealMoney" @input="businessScaleForm.setMealMoney = toRegNum(businessScaleForm.setMealMoney)" class="row-cont-input" />
            <span class="row-cont-unit">元/年</span>
          </div>
        </div>
        <div class="row" v-if="Number(businessScaleForm.setMealMoney) > 0">
          <div class="row-name" v-show="years > 0">购买年数(366×{{years}}={{366*years}}天）</div>
          <div class="row-cont row-cont-col">
            <div class="row-cont-lf">
              <div class="row-cont-lf-btn row-cont-lf-reduce" @click="toReduce">-</div>
              <div class="row-cont-lf-val">{{years}}</div>
              <div class="row-cont-lf-btn row-cont-lf-add" @click="toAdd">+</div>
            </div>
            <div class="row-cont-rt" v-show="businessScaleForm.setMealMoney">
              <div class="row-cont-rt-top">单价：{{toRegNum(businessScaleForm.setMealMoney)}}元</div>
              <div class="row-cont-rt-btm">总价：{{toRegNum(businessScaleForm.setMealMoney*years)}}元</div>
            </div>
          </div>
        </div>
        <div class="row" v-if="packageInfo.setMealAnnualFee === 1 && Number(businessScaleForm.setMealMoney) > 0">
          <div class="row-name">有效期</div>
          <div class="row-cont">
            <input type="text" placeholder="输入天数" v-model="businessScaleForm.setMealValidTime" @input="businessScaleForm.setMealValidTime = toRegNum(businessScaleForm.setMealValidTime)" class="row-cont-input" />
            <span class="row-cont-unit">天</span>
          </div>
          <Tag v-show="packageInfo.setMealValidTimeAdd > 0">
            <!-- :class="{'tag-item-active': labelNo == item.value}" -->
            <span class="tag-item" 
              v-for="(item, index) in labelList"
              :key="index"
              @click.stop="cTag(item, index)">{{item.name}}</span>
          </Tag>
        </div>
        <div class="row">
          <div class="row-name">最多可增加分店数量</div>
          <div class="row-cont">
            <input type="text" v-model="businessScaleForm.setMealShopNumber" @input="businessScaleForm.setMealShopNumber = checkNumber(businessScaleForm.setMealShopNumber)" class="row-cont-input" />
            <span class="row-cont-unit">个</span>
          </div>
        </div>
        <div class="row">
          <div class="row-name">费用单价(每增加一个分店)</div>
          <div class="row-cont">
            <input type="text" v-model="businessScaleForm.setMealAddShopMoney" @input="businessScaleForm.setMealAddShopMoney = toRegNum(businessScaleForm.setMealAddShopMoney)" class="row-cont-input" />
            <span class="row-cont-unit">元</span>
          </div>
        </div>
        <div class="row">
          <div class="row-name">图片/视频容量</div>
          <div class="row-cont">
            <input type="text" v-model="businessScaleForm.setMealUploadVideoSpace" @input="businessScaleForm.setMealUploadVideoSpace=toRegNum(businessScaleForm.setMealUploadVideoSpace)" class="row-cont-input" />
            <span class="row-cont-unit">MB</span>
          </div>
        </div>
      </div>
      <div class="section">
        <h3>技术服务费设置/云服务费：</h3>
        <div class="row">
          <div class="row-name">直销订单</div>
          <div class="row-cont">
            <input type="text" v-model="businessScaleForm.setMealMainFee" @input="businessScaleForm.setMealMainFee=toRegNum(businessScaleForm.setMealMainFee)" class="row-cont-input" />
            <span class="row-cont-unit">%</span>
          </div>
        </div>
        <div class="row">
          <div class="row-name">代销合作订单</div>
          <div class="row-cont">
            <input type="text" v-model="businessScaleForm.setMealAgentFee" @input="businessScaleForm.setMealAgentFee=toRegNum(businessScaleForm.setMealAgentFee)" class="row-cont-input" />
            <span class="row-cont-unit">%</span>
          </div>
        </div>
        <div class="row">
          <div class="row-name">自建订单</div>
          <div class="row-cont">
            <input type="text" v-model="businessScaleForm.setMealBillFee" @input="businessScaleForm.setMealBillFee=toRegNum(businessScaleForm.setMealBillFee)" class="row-cont-input" />
            <span class="row-cont-unit">%</span>
          </div>
        </div>
        <div class="row">
          <div class="row-name">聚合收款</div>
          <div class="row-cont">
            <input type="text" v-model="businessScaleForm.setMealAggregateFee" @input="businessScaleForm.setMealAggregateFee=toRegNum(businessScaleForm.setMealAggregateFee)" class="row-cont-input" />
            <span class="row-cont-unit">%</span>
          </div>
        </div>
        <div class="row">
          <div class="row-name">供应商中心获单</div>
          <div class="row-cont">
            <input type="text" v-model="businessScaleForm.setMealSupplierFee" @input="businessScaleForm.setMealSupplierFee=toRegNum(businessScaleForm.setMealSupplierFee)" class="row-cont-input" />
            <span class="row-cont-unit">%</span>
          </div>
        </div>
        <div class="row">
          <div class="row-name">提现手续费</div>
          <div class="row-cont">
            <input type="text" v-model="businessScaleForm.setMealGetMoneyFee" @input="businessScaleForm.setMealGetMoneyFee=toRegNum(businessScaleForm.setMealGetMoneyFee)" class="row-cont-input" />
            <span class="row-cont-unit">%</span>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bar"></div>
    <div class="footer">
      <div class="footer-btn default-btn" @click="toPrev">上一步</div>
      <div class="footer-btn confirm-btn" @click="onSubmit">确定</div>
    </div>
    <ContactBtn />
  </div>
</template>


<script>
import { getMealInfo, getAnnualFeeInfo,saveAnnualFee }  from '@/api/baseinfo';
export default {
  name: 'apply-package',
  data () {
    return {
      isMobile: false,
      shopCode: null,
      setMealCode: null,
      docHt: document.body.offsetHeight > 0 ? document.body.offsetHeight : document.body.clientHeight,
      labelNo:1,
      labelList:[{name:'送1个月',value:1},{name:'送2个月',value:2},{name:'送3个月',value:3}],
      packageInfo:{},
      giftTime: 0,
      defaultYear: 1,
      years: 1,
      setMealValidTime: 1, // 默认有效期年
      businessScaleForm: {
        id: null,
        isDel: 0,
        isPay: 0,
        isValid: 1,
        serviceFeeAllFee: 0,
        setMealType: 0,
        setMealValidTime: 366,
        setMealCode: null,
        setMealMoney: null,
        setMealShopNumber: null,
        setMealAddShopMoney: null,
        setMealUploadVideoSpace: null,
        setMealMainFee: null,
        setMealSaleFee: null,
        setMealAgentFee: null,
        setMealBillFee: null,
        setMealAggregateFee: null,
        setMealSupplierFee: null,
        setMealShopFee: null,
        setMealGetMoneyFee: null,
        setMealShopNumberMin: null,
        setMealShopNumberMax: null,
        setMealAddShopMoneyMin: null,
        setMealAddShopMoneyMax: null
      },
      isRepeat: false
    }
  },
  created() {
    let scaleFormInfo = sessionStorage.getItem('scaleFormInfo')?JSON.parse(sessionStorage.getItem('scaleFormInfo')):null;
    let scaleInfo = sessionStorage.getItem('scaleInfo')?JSON.parse(sessionStorage.getItem('scaleInfo')):null;
    if(scaleFormInfo||scaleInfo){
      this.businessScaleForm = scaleFormInfo;
      this.businessScaleForm.setMealMoney = scaleFormInfo.setMealMoney;
      this.businessScaleForm.setMealAddShopMoney = scaleFormInfo.setMealAddShopMoney;
      this.shopCode = scaleInfo.shopMallCode;
      this.setMealCode = scaleInfo.setMealCode;
      this.packageInfo = JSON.parse(JSON.stringify(this.businessScaleForm));
      this.packageInfo.setMealAnnualFee = scaleFormInfo.setMealAnnualFee;
      this.packageInfo.setMealFixedMoney = scaleFormInfo.setMealFixedMoney;
      this.packageInfo.setMealValidTimeAdd = scaleFormInfo.setMealValidTimeAdd;
      this.getMealInfo();
    }else{
      this.shopCode = this.$route.query ? this.$route.query.shopCode : null;
      this.setMealCode = this.$route.query ? this.$route.query.setMealCode : '';
      this.getMealInfo();
    }
    this.mobileTerminal((data) => {
      this.isMobile = data
    })
  },
  methods: {
    getMealInfo() {
      getMealInfo(this.setMealCode).then(res => {
        if(res.code === 200) {
          if(!res.data) return false;
          this.getAnnualFee(res.data);
        } else {
          this.Toast('请选择套餐后重试~');
        }
      })
    },
    getAnnualFee(data) {
      let setMealMoney = '';
      let setMealValidTime = '';
      this.defaultYear = data.setMealValidTime ? data.setMealValidTime : 1;
      this.years = data.setMealValidTime ? data.setMealValidTime : 1;
      this.setMealValidTime = data.setMealValidTime ? data.setMealValidTime : 1;
      setMealValidTime = (366*this.years)+(this.giftTime*30);

      let scaleFormInfo = sessionStorage.getItem('scaleFormInfo')?JSON.parse(sessionStorage.getItem('scaleFormInfo')):null;
      if(!scaleFormInfo){
        data.setMealMoney = data.setMealMoney > 0 ? (data.setMealMoney/100) : 0;
        data.setMealMoneyMin = data.setMealMoneyMin > 0 ? (data.setMealMoneyMin/100) : 0;
        data.setMealMoneyMax = data.setMealMoneyMax > 0 ? (data.setMealMoneyMax/100) : 0;
        data.setMealGetMoneyMin = data.setMealGetMoneyMin > 0 ? (data.setMealGetMoneyMin/100) : '';
        data.setMealGetMoneyMax = data.setMealGetMoneyMax > 0 ? (data.setMealGetMoneyMax/100) : '';
        data.setMealGetMoneyDayMax = data.setMealGetMoneyDayMax > 0 ? (data.setMealGetMoneyDayMax/100) : '';
        data.setMealAddShopMoneyMin = data.setMealAddShopMoneyMin > 0 ? (data.setMealAddShopMoneyMin/100) : '';
        data.setMealAddShopMoneyMax = data.setMealAddShopMoneyMax > 0 ? (data.setMealAddShopMoneyMax/100) : '';
        // 是否有年费
        if(data.setMealAnnualFee == 1) {
          if(data.setMealSales == 1) {
            if(data.setMealFixedMoney == 1) {
              // 固定年费
              setMealMoney = this.toRegNum(data.setMealMoney/data.setMealValidTime) || 0;
            } else if(data.setMealFixedMoney == 0) {
              // 市场人员固定年费
              setMealMoney = this.toRegNum(data.setMealMoneyMax/data.setMealValidTime) || this.toRegNum(data.setMealMoneyMin/data.setMealValidTime) || 0;
            }
          } else {
            setMealMoney = this.toRegNum(data.setMealMoney/data.setMealValidTime) || 0;
          }
        }
        this.businessScaleForm = {
          isDel: data.isDel,
          isPay: data.isPay,
          isValid: data.isValid,
          serviceFeeAllFee: data.serviceFeeAllFee,
          setMealType: data.setMealType,
          setMealValidTime,
          setMealValidTimeAdd: data.setMealValidTimeAdd,
          setMealCode: data.setMealCode,
          setMealMoney,
          setMealShopNumber: data.setMealShopNumberMax ? data.setMealShopNumberMax : data.setMealShopNumberMin || '',
          setMealAddShopMoney: data.setMealAddShopMoneyMax ? data.setMealAddShopMoneyMax : data.setMealAddShopMoneyMin || '',
          setMealUploadVideoSpace: data.setMealUploadVideoSpace,
          setMealMainFee: data.setMealMainFeeMax ? data.setMealMainFeeMax : data.setMealMainFeeMin || '',
          setMealSaleFee: data.setMealSaleFeeMax ? data.setMealSaleFeeMax : data.setMealSaleFeeMin || '',
          setMealAgentFee: data.setMealAgentFeeMax ? data.setMealAgentFeeMax : data.setMealAgentFeeMin || '',
          setMealSupplierFee: data.setMealSupplierFeeMax ? data.setMealSupplierFeeMax : data.setMealSupplierFeeMin || '',
          setMealShopFee: data.setMealShopFeeMax ? data.setMealShopFeeMax : data.setMealShopFeeMin || '',
          setMealGetMoneyFee: data.setMealGetMoneyFeeMax ? data.setMealGetMoneyFeeMax : data.setMealGetMoneyFeeMin || '',
          setMealBillFee: data.setMealBillFeeMax? data.setMealBillFeeMax : data.setMealBillFeeMin || '',
          setMealAggregateFee: data.setMealAggregateFeeMax? data.setMealAggregateFeeMax : data.setMealAggregateFeeMin || '',
        }
      }
      this.packageInfo = JSON.parse(JSON.stringify(this.businessScaleForm));
      this.packageInfo.setMealAnnualFee = data.setMealAnnualFee;
      this.packageInfo.setMealFixedMoney = data.setMealFixedMoney;
      this.packageInfo.setMealValidTimeAdd = data.setMealValidTimeAdd;
    },
    setDefault(){
      this.businessScaleForm = JSON.parse(JSON.stringify(this.packageInfo));
      this.years = this.defaultYear;
      this.giftTime = 0;
    },
    toReduce() {
      if(this.years === this.setMealValidTime) return false;
      let num = this.setMealValidTime;
      this.years -= num;
      this.businessScaleForm.setMealValidTime = (366*this.years)+(this.giftTime*30);
    },
    toAdd() {
      let num = this.setMealValidTime;
      this.years += num;
      this.businessScaleForm.setMealValidTime = (366*this.years)+(this.giftTime*30);
    },
    cTag(item){
      this.giftTime = item.value;
      this.businessScaleForm.setMealValidTime = (366*this.years)+(item.value*30);
    },
    toPrev() {
      this.$router.go(-1);
    },
    onSubmit() {
      if(this.businessScaleForm.setMealValidTimeAdd){
        if(this.businessScaleForm.setMealValidTime>((366*this.years)+Number(this.businessScaleForm.setMealValidTimeAdd))) return this.Toast('有效期天数超出了总天数~');
      } else {
        if(this.businessScaleForm.setMealValidTime>(366*this.years)) return this.Toast('有效期天数超出了总天数~');
      }
      if(this.packageInfo.setMealFixedMoney == 0) {
        if(+this.businessScaleForm.setMealMoney < +this.packageInfo.setMealMoneyMin || +this.businessScaleForm.setMealMoney > +this.packageInfo.setMealMoneyMax) return this.Toast('年费固定金额需在已设定范围内~');
      }
      if(this.packageInfo.setMealShopNumberMin) {
        if(+this.businessScaleForm.setMealShopNumber < +this.packageInfo.setMealShopNumberMin) return this.Toast('门店数量需在已设定范围内~');
      }
      if(this.packageInfo.setMealShopNumberMax) {
        if(+this.businessScaleForm.setMealShopNumber > +this.packageInfo.setMealShopNumberMax) return this.Toast('门店数量需在已设定范围内~');
      }
      if(this.packageInfo.setMealAddShopMoneyMin) {
        if(+this.businessScaleForm.setMealAddShopMoney < +this.packageInfo.setMealAddShopMoneyMin) return this.Toast('增加的门店费用单价需在已设定范围内~');
      }
      if(this.packageInfo.setMealAddShopMoneyMax) {
        if(+this.businessScaleForm.setMealAddShopMoney > +this.packageInfo.setMealAddShopMoneyMax) return this.Toast('增加的门店费用单价需在已设定范围内~');
      }
      if(+this.businessScaleForm.setMealUploadVideoSpace > +this.packageInfo.setMealUploadVideoSpace) return this.Toast('图片/视频容量不可超过已设定最大值~');
      if(this.packageInfo.setMealMainFeeMin) {
        if(+this.businessScaleForm.setMealMainFee < +this.packageInfo.setMealMainFeeMin) return this.Toast('直销订单比例需在已设定范围内~');
      }
      if(this.packageInfo.setMealMainFeeMax) {
        if(+this.businessScaleForm.setMealMainFee > +this.packageInfo.setMealMainFeeMax) return this.Toast('直销订单比例需在已设定范围内~');
      }
      if(this.packageInfo.setMealAgentFeeMin) {
        if(+this.businessScaleForm.setMealAgentFee < +this.packageInfo.setMealAgentFeeMin) return this.Toast('代销合作订单比例需在已设定范围内~');
      }
      if(this.packageInfo.setMealAgentFeeMax) {
        if(+this.businessScaleForm.setMealAgentFee > +this.packageInfo.setMealAgentFeeMax) return this.Toast('代销合作订单比例需在已设定范围内~');
      }
      if(this.packageInfo.setMealBillFeeMin) {
        if(+this.businessScaleForm.setMealBillFee < +this.packageInfo.setMealBillFeeMin) return this.Toast('自建订单比例需在已设定范围内~');
      }
      if(this.packageInfo.setMealBillFeeMax) {
        if(+this.businessScaleForm.setMealBillFee > +this.packageInfo.setMealBillFeeMax) return this.Toast('自建订单比例需在已设定范围内~');
      }
      if(this.packageInfo.setMealAggregateFeeMin) {
        if(+this.businessScaleForm.setMealAggregateFee < +this.packageInfo.setMealAggregateFeeMin) return this.Toast('聚合收款比例需在已设定范围内~');
      }
      if(this.packageInfo.setMealAggregateFeeMax) {
        if(+this.businessScaleForm.setMealAggregateFee > +this.packageInfo.setMealAggregateFeeMax) return this.Toast('聚合收款比例需在已设定范围内~');
      }
      if(this.packageInfo.setMealSupplierFeeMi) {
        if(+this.businessScaleForm.setMealSupplierFee < +this.packageInfo.setMealSupplierFeeMin) return this.Toast('采购中心获单比例需在已设定范围内~');
      }
      if(this.packageInfo.setMealSupplierFeeMax) {
        if(+this.businessScaleForm.setMealSupplierFee > +this.packageInfo.setMealSupplierFeeMax) return this.Toast('采购中心获单比例需在已设定范围内~');
      }
      if(this.packageInfo.setMealSupplierFeeMin) {
        if(+this.businessScaleForm.setMealSupplierFee < +this.packageInfo.setMealSupplierFeeMin) return this.Toast('采购中心获单比例需在已设定范围内~');
      }
      if(this.packageInfo.setMealSupplierFeeMax) {
        if(+this.businessScaleForm.setMealSupplierFee > +this.packageInfo.setMealSupplierFeeMax) return this.Toast('采购中心获单比例需在已设定范围内~');
      }
      if(this.packageInfo.setMealGetMoneyFeeMin) {
        if(+this.businessScaleForm.setMealGetMoneyFee < +this.packageInfo.setMealGetMoneyFeeMin) return this.Toast('提现手续费比例需在已设定范围内~');
      }
      if(this.packageInfo.setMealGetMoneyFeeMax) {
        if(+this.businessScaleForm.setMealGetMoneyFee > +this.packageInfo.setMealGetMoneyFeeMax) return this.Toast('提现手续费比例需在已设定范围内~');
      }
      if(this.businessScaleForm.setMealValidTime>(this.packageInfo.setMealValidTimeAdd+(366*this.years))) return this.Toast('有效期天数不可大于最多赠送天数~');
      let params = {};
      let setMealMoney = JSON.parse(JSON.stringify(this.businessScaleForm.setMealMoney));
      let setMealAddShopMoney = JSON.parse(JSON.stringify(this.businessScaleForm.setMealAddShopMoney));
      params = JSON.parse(JSON.stringify(this.businessScaleForm));
      params.shopMallCode = this.shopCode;
      params.setMealCode = this.setMealCode;
      params.setMealMoney = setMealMoney*100;
      params.setMealAddShopMoney = setMealAddShopMoney*100;
      params.buyTime = Number(this.years);
      if(this.isRepeat) return false;
      this.isRepeat = true;
      saveAnnualFee(params).then(res => {
        this.isRepeat = false;
        if(res.code === 200) {
          sessionStorage.setItem('scaleFormInfo', JSON.stringify(this.businessScaleForm));
          sessionStorage.setItem('scaleInfo', JSON.stringify(params));
          this.$router.push({
            path: '/market-ratio?shopCode=' + this.shopCode
          })
          // if(params.setMealMoney > 0) {
          //   this.$router.push({
          //     path: '/market-ratio?shopCode=' + this.shopCode
          //   })
          // }
        } else {
          this.Toast('请完善信息后重试~');
        }
      }).catch(err=>{
        this.isRepeat = false;
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container{
  padding-top: 20px;
}
.set-default{
  font-size: 14px;
  color: #67B4C4;
  text-align: right;
  margin: 0 20px 20px;
}
.section{
  margin-bottom: 40px;
  h3{
    font-size: 16px;
    color: #222;
    margin: 0 20px 12px;
  }
}
.row{
  margin: 0 20px 20px;
  &:last-child{
    margin-bottom: 0;
  }
  &-name{
    line-height: 20px;
    font-size: 14px;
    color: #666;
    margin-bottom: 8px;
  }
  &-cont{
    display: flex;
    &-col{
      align-items: center;
    }
    &-input{
      width: calc(100% - 64px);
      height: 48px;
      background: #FFFFFF;
      border-radius: 10px;
      border: 1px solid #D8E0F0;
      font-size: 14px;
      color: #222;
      display: flex;
      align-items: left;
      padding: 0 10px;
      box-sizing: border-box;
      border-radius: 10px 0 0 10px;
      border-right: 0px;
    }
    &-unit{
      width: 64px;
      height: 48px;
      background: #FFFFFF;
      border-radius: 0px 10px 10px 0px;
      border: 1px solid #D8E0F0;
      box-sizing: border-box;
      font-size: 14px;
      color: #7D8592;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &-rt{
      line-height: 20px;
      margin-left: 20px;
      font-size: 14px;
      color: #0A1629;
      font-weight: 500;
    }
    &-lf{
      display: flex;
      align-items: center;
      border: 1px solid #D8E0F0;
      border-radius: 10px;
      &-val{
        width: 84px;
        height: 48px;
        line-height: 48px;
        padding: 0 10px;
        box-sizing: border-box;
        border-left: 1px solid #D8E0F0;
        border-right: 1px solid #D8E0F0;
        font-size: 14px;
        color: #222;
        text-align: center;
      }
      &-btn{
        width: 48px;
        height: 48px;
        background: #FFFFFF;
        font-size: 24px;
        color: #7B8593;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &-reduce{
        border-radius: 10px 0px 0px 10px;
      }
      &-add{
        border-radius: 0px 10px 10px 0px;
      }
      &-input{
        width: 84px;
        height: 48px;
        font-size: 14px;
        color: #222;
        font-weight: 500;
        border-left: 1px solid #D8E0F0;
        border-right: 1px solid #D8E0F0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .tag-group{
    margin-top: 10px;
    .tag-item-active{
      background: #ECF7F9;
      color: #67B4C4;
      border: 0;
    }
  }
}


.footer{
  display: flex;
  align-items: center;
  justify-content: center;
  &-btn{
    width: 130px;
    height: 44px;
    border-radius: 10px;
    font-size: 16px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 12px;
  }
  .default-btn{
    background: #FFFFFF;
    border: 1px solid #EEEEEE;  
    color: #222;
  }
  .confirm-btn{
    background: #67B4C4;
    color: #fff;
  }
}
@media screen and (max-width:750px){

}
@media screen and (min-width:750px){
  
}
</style>



// WEBPACK FOOTER //
// src/views/merchantRatio.vue